module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image2-fd7f0d9a26eaf8c1e97eff5ab1ba1e85.png";